var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandschaft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Legende_Landschaft__Icn/40px/Legende/Landschaft",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.785823,19.0070801 L18.214177,20.9606699 L17.8581212,21.0419538 C14.3566433,21.8740825 12.6114815,23.291733 11.1764824,25.9098652 L11.129,25.999 L32,26 L32,28 L10,28 L9.88337887,27.9932723 C9.38604019,27.9355072 9,27.5128358 9,27 L9,26 L9.00681304,25.8834667 C9.02039332,25.7677261 9.05413794,25.6549418 9.10681042,25.5503197 C10.9023449,21.983891 13.173117,20.0184853 17.785823,19.0070801 Z M23.4603271,10.0802002 L26.748,18.299 L28.465332,14.0059814 L32.465332,24.0059814 L24.465332,24.0059814 L26.035,20.08 L19.4603271,20.0802002 L23.4603271,10.0802002 Z M28.465,19.391 L27.419,22.005 L29.511,22.005 L28.465,19.391 Z M23.46,15.464 L22.414,18.08 L24.506,18.08 L23.46,15.464 Z M12,10 C13.6568542,10 15,11.3431458 15,13 C15,14.6568542 13.6568542,16 12,16 C10.3431458,16 9,14.6568542 9,13 C9,11.3431458 10.3431458,10 12,10 Z M12,12 C11.4477153,12 11,12.4477153 11,13 C11,13.5522847 11.4477153,14 12,14 C12.5522847,14 13,13.5522847 13,13 C13,12.4477153 12.5522847,12 12,12 Z",
    id: ".._.._src_svg_Icn_40px_Legende_Landschaft__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandschaft);
export default __webpack_public_path__ + "static/media/Landschaft.b1715a434b2de21e163b2144e9fce0e9.svg";
export { ForwardRef as ReactComponent };